export interface UploadResponse {
  success: boolean;
  data?: {
    id: string;
    downloadUrl: string;
    filename: string;
    size: number;
    expiresAt?: string;
  };
  error?: string;
}

export interface DownloadRequest {
  id: string;
  password?: string;
}

export interface FileMetadata {
  id: string;
  filename: string;
  originalName: string;
  size: number;
  mimetype: string;
  uploadedAt: string;
  expiresAt?: string;
  password?: string;
  downloadCount: number;
  maxDownloads?: number;
}

export interface UploadRequest {
  filename: string;
  size: number;
  mimetype: string;
  expiresIn?: number; // hours
  password?: string;
  maxDownloads?: number;
}

export interface ApiResponse<T = any> {
  success: boolean;
  data?: T;
  error?: string;
}

export const MAX_FILE_SIZE = 2 * 1024 * 1024 * 1024; // 2GB
export const DEFAULT_EXPIRY_HOURS = 24 * 7; // 7 days
export const ALLOWED_MIME_TYPES = [
  'image/*',
  'video/*',
  'audio/*',
  'application/pdf',
  'application/zip',
  'application/x-zip-compressed',
  'application/x-rar-compressed',
  'text/*',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation'
]; 